import React, { useEffect, useState } from 'react';
import { isBrowser } from 'utils/helpers';

import CustomModal from './CustomModal';

export type MultipleModalsProps = {
  modals: {
    id: string;
    heading?: string;
    content: React.ReactNode;
    cta?: {
      label?: string;
      url?: string;
    };
  }[];
};

export default function MultipleModals({ modals }: MultipleModalsProps) {
  const [selectedModal, setSelectedModal] = useState('');

  const isBrowerAvailable = isBrowser();

  useEffect(() => {
    if (!isBrowerAvailable) {
      return;
    }
    const handleClick: EventListenerOrEventListenerObject = (event) => {
      event.preventDefault();

      const modalId = (event.target as HTMLElement)
        ?.getAttribute('href')
        ?.split('#')[1];

      if (!modalId) return;

      const doesModalExist = modals?.some((modal) => modal.id === modalId);

      if (!doesModalExist) return;

      setSelectedModal(modalId);
    };

    const modalTriggers = window.document.querySelectorAll('[href*="#"]');

    modalTriggers.forEach((modalTrigger) => {
      modalTrigger.addEventListener('click', handleClick);
    });

    return () => {
      modalTriggers.forEach((modalTrigger) => {
        modalTrigger.removeEventListener('click', handleClick);
      });
    };
  }, [isBrowerAvailable, modals]);

  return (
    <>
      {modals?.map((modal) => (
        <CustomModal
          key={modal?.id}
          isModalOpen={selectedModal === modal.id}
          handleClose={() => setSelectedModal('')}
          {...modal}
        />
      ))}
    </>
  );
}
